/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：434
 */

"use strict"

function r(e, t) {
  e.prototype = Object.create(t.prototype)
  e.prototype.constructor = e
  e.__proto__ = t
}
export { r as a }
export default r
